import React, { Component } from 'react'

import StagesManager from '../../../components/StagesManager'
import LicenceControlMain from './LicenceControlMain'
import UpgradeAccount from '../UpgradeAccount'
import YonnectCartPage from '../YonnectCartPage'

export default class LicenceControl extends Component {
    state = {

    }


    componentDidMount() {

        this.checkDefaultTab()

    }


    componentDidUpdate(prevProps) {

        if ((JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path))) {

            this.setState({ oldData: this.props.windowData }, () => {
                this.checkDefaultTab()
            })

        }
    }


    checkDefaultTab() {
       
        let slug = this.props.windowData.path[this.props.baseUrl.length]

        if (!slug || slug == '') {
            slug = 'main'
        }

        this.stageManager.changeStage(slug.toLowerCase())

    }



    render() {
        return (
            <div className='h-100'>


                <StagesManager height={'100%'} ref={el => this.stageManager = el} fast={true}  >

                    <LicenceControlMain stage={1} stageName={'main'} windowData={this.props.windowData} baseUrl={[...this.props.baseUrl]} variables={this.props.variables} width={this.props.width} height={this.props.height} changeWindow={this.props.changeWindow} colors={this.props.colors} permissions={this.props.permissions} setHeader={this.props.setHeader} page={this.props.page} applet={this.props.applet} headers={this.props.headers} automations={this.props.automations} language={this.props.language} userSettings={this.props.userSettings} changeWindowLink={this.props.changeWindowLink} changePage={this.props.changePage} />
                    <UpgradeAccount stage={1} stageName={'upgrade'} windowData={this.props.windowData} baseUrl={[...this.props.baseUrl]} variables={this.props.variables} width={this.props.width} height={this.props.height} changeWindow={this.props.changeWindow} colors={this.props.colors} permissions={this.props.permissions} setHeader={this.props.setHeader} page={this.props.page} applet={this.props.applet} headers={this.props.headers} automations={this.props.automations} language={this.props.language} userSettings={this.props.userSettings} changeWindowLink={this.props.changeWindowLink} changePage={this.props.changePage} />
                    <YonnectCartPage stage={1} stageName={'payment'} windowData={this.props.windowData} baseUrl={[...this.props.baseUrl]} variables={this.props.variables} width={this.props.width} height={this.props.height} changeWindow={this.props.changeWindow} colors={this.props.colors} permissions={this.props.permissions} setHeader={this.props.setHeader} page={this.props.page} applet={this.props.applet} headers={this.props.headers} automations={this.props.automations} language={this.props.language} userSettings={this.props.userSettings} changeWindowLink={this.props.changeWindowLink} changePage={this.props.changePage} />

                </StagesManager>


            </div>
        )
    }
}
